<app-selector
  label="Fruit Ninja Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="fruitNinjaGameCoreService.fruitNinjaGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="fruitNinjaGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
